document.addEventListener("DOMContentLoaded", function () {

    const popup = document.querySelector(".search-popup");
    const openBtns = document.querySelectorAll(".searchCustType");
    const closeBtn = document.querySelector(".closeIconP");
    const resultBox = document.getElementById("predictive-results");

    // Open popup
    openBtns.forEach(btn => {
        btn.addEventListener("click", function (e) {
            e.preventDefault();
            popup.classList.add("activePop");
            setTimeout(() => {
                const input = document.getElementById("predictive-search-input");
                if (input) input.focus();
            }, 100);
        });
    });

    // --- CLOSE POPUP LOGIC ---

    // 1. Close via specific close button
    if (closeBtn) {
        closeBtn.addEventListener("click", function (e) {
            e.preventDefault();
            popup.classList.remove("activePop");
            if (resultBox) resultBox.innerHTML = ""; // Replaced .hide() with vanilla JS
        });
    }

    // 2. Close on click outside
    document.addEventListener("click", function (e) {
        // Only run if the popup is currently active
        if (popup && popup.classList.contains("activePop")) {
            
            // Check if the click was inside the popup
            const isClickInsidePopup = popup.contains(e.target);
            
            // Check if the click was on one of the buttons used to open the popup
            let isClickOnOpenBtn = false;
            openBtns.forEach(btn => {
                if (btn.contains(e.target)) {
                    isClickOnOpenBtn = true;
                }
            });

            // If clicked outside the popup AND not on an open button, close it
            if (!isClickInsidePopup && !isClickOnOpenBtn) {
                popup.classList.remove("activePop");
                if (resultBox) resultBox.innerHTML = ""; // Replaced .hide() with vanilla JS
            }
        }
    });

    // 3. Close on 'Escape' key press (Best Practice)
    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && popup && popup.classList.contains("activePop")) {
            popup.classList.remove("activePop");
            if (resultBox) resultBox.innerHTML = ""; // Replaced .hide() with vanilla JS
        }
    });

    // Search functionality
    const input = document.getElementById("predictive-search-input");
    const results = document.getElementById("predictive-results");
    let timer;

    if (input && results) {
        input.addEventListener("input", function () {
            clearTimeout(timer);
            const q = this.value.trim();

            if (q.length < 3) {
                results.innerHTML = "";
                return;
            }

            timer = setTimeout(function () {
                
                // Safely grab the root and guarantee it ends with a slash (handles locales)
                let rootUrl = window.Shopify?.routes?.root || "/";
                if (!rootUrl.endsWith('/')) {
                    rootUrl += '/';
                }
                
                // Construct your custom URL
                const fetchUrl = `${rootUrl}search?type=product&q=${encodeURIComponent(q + "*")}&view=json`;

                fetch(fetchUrl, {
                    method: "GET",
                    headers: {
                        "Accept": "application/json"
                    }
                })
                .then(async res => {
                    if (!res.ok) throw new Error(`Status ${res.status}: Network error.`);
                    
                    const contentType = res.headers.get("content-type");
                    if (!contentType || !contentType.includes("application/json")) {
                        throw new TypeError("Returned HTML instead of JSON. Check your search.json.liquid template.");
                    }

                    return res.json();
                })
                .then(data => {
                    // Custom templates vary. This tries to find your product array whether 
                    // it is stored inside { results: [] }, { products: [] }, or just []
                    let products = [];
                    if (Array.isArray(data)) {
                        products = data;
                    } else {
                        products = data.results || data.products || data.items || [];
                    }

                    if (products.length === 0) {
                        results.innerHTML = `<div class="search-no-result">לא נמצאו תוצאות</div>`;
                        return;
                    }

                    // --- ADD YOUR LIMIT HERE ---
                    // Change the '5' to the maximum number of products you want to display
                    const maxResults = 5; 
                    products = products.slice(0, maxResults);
                    // ---------------------------

                    renderProducts(products, q, rootUrl);
                })
                .catch(err => {
                    console.error("Predictive Search Error:", err.message);
                    results.innerHTML = `<div class="search-no-result">אירעה שגיאה. יש לבדוק את הקונסול.</div>`;
                });

            }, 300);
        });
    }

    // Render function
    // Render function
    function renderProducts(products, keyword, rootUrl) {
        let listItemsHtml = '';

        // 1. Build the HTML for the list items
        products.forEach((product, index) => {
            let rawImage = product.image || product.featured_image || product.thumbnail || '';
            let imageUrl = typeof rawImage === 'object' ? rawImage.src || rawImage.url : rawImage;
            if (imageUrl && imageUrl.startsWith('//')) {
                imageUrl = 'https:' + imageUrl;
            }

            let url = product.url || `/products/${product.handle}`;

            listItemsHtml += `
            <li class="predictive-list-item" data-index="${index}">
                <a href="${url}" class="predictive-item">
                    <div class="predictive-image">
                        ${imageUrl ? `<img src="${imageUrl}" alt="${product.title || ''}">` : ''}
                    </div>
                    <div class="predictive-info">
                        <div class="predictive-title">${product.title || 'Unknown Product'}</div>
                    </div>
                </a>
            </li>
            `;
        });

        const viewAllUrl = `${rootUrl}search?q=${encodeURIComponent(keyword)}`.replace(/([^:])\/\//g, '$1/');

        // 2. Build the main wrapper
        let html = `
        <div class="predictive-wrapper flex-layout">
            
            <!-- Hover Popover Container -->
            <div class="predictive-preview" id="predictive-preview" style="visibility: hidden; opacity: 0;">
                <!-- Hover content injected here -->
            </div>

            <!-- Standard Dropdown List -->
            <div class="predictive-results-container">
                <div class="predictive-header">מוצרים</div>
                <ul class="predictive-list">
                    ${listItemsHtml}
                </ul>
                <a class="view-all-search" href="${viewAllUrl}">
                    הצג את כל התוצאות
                </a>
            </div>

        </div>`;

        results.innerHTML = html;

        // 3. Elements for hover logic
        const wrapper = results.querySelector('.predictive-wrapper');
        const listItems = results.querySelectorAll('.predictive-list-item');
        const previewBox = document.getElementById('predictive-preview');

        // Helper function to update content AND vertical position
        function updatePreview(index, targetElement) {
            if (!products[index]) return;
            const product = products[index];

            let rawImage = product.image || product.featured_image || product.thumbnail || '';
            let imageUrl = typeof rawImage === 'object' ? rawImage.src || rawImage.url : rawImage;
            if (imageUrl && imageUrl.startsWith('//')) imageUrl = 'https:' + imageUrl;
            
            let url = product.url || `/products/${product.handle}`;
            let desc = product.description || product.body_html || ''; 

            previewBox.innerHTML = `
                <div class="preview-header">
                    <div class="preview-title">${product.title || ''}</div>
                    <div class="preview-price">${product.price || ''}</div>
                </div>
                <div class="preview-image-large">
                    ${imageUrl ? `<img src="${imageUrl}" alt="">` : ''}
                </div>
                <div class="preview-description">
                    ${desc.substring(0, 180)}${desc.length > 180 ? '...' : ''}
                </div>
                <div class="preview-link-container">
                    <a href="${url}" class="preview-link">לדף המוצר</a>
                </div>
            `;

            previewBox.style.visibility = 'visible';
            previewBox.style.opacity = '1';

            // --- NEW: Calculate and apply the dynamic top position ---
            if (targetElement && wrapper) {
                const wrapperRect = wrapper.getBoundingClientRect();
                const itemRect = targetElement.getBoundingClientRect();
                
                // Calculate the distance from the top of the wrapper to the top of the list item
                const relativeTop = itemRect.top - wrapperRect.top;
                
                // Apply it to the preview box
                previewBox.style.top = `${relativeTop}px`;
            }
        }

        // 4. Initialize the default view (Wait a tiny bit to ensure DOM is painted for calculation)
        if (products.length > 0) {
            setTimeout(() => {
                if (listItems[0]) {
                    listItems[0].classList.add('is-active-item');
                    updatePreview(0, listItems[0]);
                }
            }, 50);
        }

        // 5. Attach Hover Events
        listItems.forEach(item => {
            item.addEventListener('mouseenter', function() {
                listItems.forEach(li => li.classList.remove('is-active-item'));
                this.classList.add('is-active-item');
                
                const index = this.getAttribute('data-index');
                updatePreview(index, this); // Pass 'this' as the target element
            });
        });

        // 6. Reset to the first item if the mouse leaves the dropdown
        if (wrapper) {
            wrapper.addEventListener('mouseleave', () => {
                if (products.length > 0 && listItems[0]) {
                    listItems.forEach(li => li.classList.remove('is-active-item'));
                    listItems[0].classList.add('is-active-item');
                    updatePreview(0, listItems[0]);
                }
            });
        }
    }
});